<div class="section-message section-message__{{ type }}"
     [class.section-message--with-action]="actionLabel">
    <div class="section-message__icon">
        <img *ngIf="icon" [src]="icon" alt="" class="icon-size">
        <img *ngIf="!icon && type === 'warning'" src="../../../../../assets/icons/info.svg" alt="" class="icon-size">
        <img *ngIf="!icon && type === 'informative'" src="../../../../../assets/icons/info-new.svg" alt="" class="icon-size">
        <img *ngIf="!icon && type === 'fapro'" src="../../../../../assets/icons/lock_icon.svg" alt="" class="icon-size">
    </div>
    <div class="section-message-info">
        <div *ngIf="title" class="section-message-info__title">
            {{ title }}
        </div>
        <div class="section-message-info__text">
            {{ text }}
        </div>
    </div>
    <button *ngIf="actionLabel" type="button" class="section-message__action"
            (click)="actionClick.emit()">
        {{ actionLabel }}
    </button>
</div>
